// TODO later it probably deserves splitting, now it's fine
export const routeUrls = {
    audienceTargeting: () => '/audience-targeting',
    // Redesign A/B route for Audience Targeting. The legacy `audienceTargeting` route above is left untouched.
    audienceTargetingRedesign: () => '/nova/audience-targeting',
    steamSales: () => '/steam-sales',
    dashboard: () => '/campaign-dashboard',
    // Redesign (nova) demo of the brand campaign dashboard: a brand-gated in-app preview that renders the
    // shared dashboard with static demo data (mirrors the legacy `/demo-campaign-dashboard`, which requires
    // brand authentication and bounces logged-out users to login). Single source of truth for the clean route.
    demoCampaignDashboardRedesign: () => '/nova/demo-campaign-dashboard',
    creatorsTwitch: (mnemonicId) => `/creators/twitch/${mnemonicId}`,
    creatorsYoutube: (mnemonicId) => `/creators/yt/${mnemonicId}`,
    creatorsTiktok: (mnemonicId) => `/creators/tiktok/${mnemonicId}`,
    creatorsFacebook: (mnemonicId) => `/creators/facebook/${mnemonicId}`,
    // Redesign (nova) creator-profile builders. The legacy profile keeps platform-specific URL forms
    // (`/creators/twitch/:id` etc.); the nova twins mirror that structure 1:1 so redesign navigation
    // keeps the same path and does not bounce through the legacy route.
    creatorsTwitchRedesign: (mnemonicId) => `/nova/creators/twitch/${mnemonicId}`,
    creatorsYoutubeRedesign: (mnemonicId) => `/nova/creators/yt/${mnemonicId}`,
    creatorsTiktokRedesign: (mnemonicId) => `/nova/creators/tiktok/${mnemonicId}`,
    drop: (mnemonicId, hash) => {
        if (hash) {
            return `/e/${mnemonicId}#${hash}`;
        }
        return `/e/${mnemonicId}`;
    },
    // Redesign (nova) twin of `drop`. Redesign-internal navigation must target this directly so a
    // cohort user never bounces through the legacy `/e/:id` (which would flash the old UI before the
    // A/B redirect). Mirrors `drop`'s params.
    dropRedesign: (mnemonicId, hash) => (hash ? `/nova/drop/${mnemonicId}#${hash}` : `/nova/drop/${mnemonicId}`),
    dare: (recordId) => `/dare/${recordId}`,
    // Redesign (nova) twin of `dare` (the View Dare / project detail page). Redesign-internal
    // navigation must target this directly so a cohort user never bounces through the legacy
    // `/dare/:recordId` (which would flash the old UI before the A/B redirect).
    dareRedesign: (recordId) => `/nova/dare/${recordId}`,
    drops: (params) => {
        const searchParams = new URLSearchParams('');
        if ((params === null || params === void 0 ? void 0 : params.onboarding) !== undefined) {
            searchParams.set('onboarding', String(params.onboarding));
        }
        if (params === null || params === void 0 ? void 0 : params.mnemonicId) {
            searchParams.set('mnemonicId', params.mnemonicId);
        }
        if (params === null || params === void 0 ? void 0 : params.tab) {
            searchParams.set('status', params.tab);
        }
        const searchParamsString = searchParams.toString();
        if (searchParamsString) {
            return `/drops?${searchParamsString}`;
        }
        return '/drops';
    },
    // Redesign (nova) twin of `drops`. Mirrors its params but targets `/nova/drops` so redesign
    // navigation does not bounce through the legacy list (which would flash the old UI).
    dropsRedesign: (params) => {
        const searchParams = new URLSearchParams('');
        if ((params === null || params === void 0 ? void 0 : params.onboarding) !== undefined) {
            searchParams.set('onboarding', String(params.onboarding));
        }
        if (params === null || params === void 0 ? void 0 : params.mnemonicId) {
            searchParams.set('mnemonicId', params.mnemonicId);
        }
        if (params === null || params === void 0 ? void 0 : params.tab) {
            searchParams.set('status', params.tab);
        }
        const searchParamsString = searchParams.toString();
        return searchParamsString ? `/nova/drops?${searchParamsString}` : '/nova/drops';
    },
    giveawayHistory: () => '/giveaway-history',
    giveawayRewards: () => '/giveaway-rewards',
    brandUsers: () => '/brand-users',
    signUpToken: () => '/sign-up-token',
    signIn: () => '/sign-in',
    signUp: () => '/sign-up',
    verifyAccount: () => '/verify-account',
    keysAndProducts: () => '/keys-and-products',
    addCampaign: ({ dropId, publish } = {}) => {
        const queryParams = new URLSearchParams();
        if (publish) {
            queryParams.set('publish', 'true');
        }
        if (dropId) {
            queryParams.set('dropId', dropId);
        }
        const queryString = queryParams.toString();
        return `/add-campaign${queryString ? `?${queryString.toString()}` : ''}`;
    },
    // Redesign (nova) twin of `addCampaign`. Mirrors its params but targets `/nova/add-campaign`.
    addCampaignRedesign: ({ dropId, publish } = {}) => {
        const queryParams = new URLSearchParams();
        if (publish) {
            queryParams.set('publish', 'true');
        }
        if (dropId) {
            queryParams.set('dropId', dropId);
        }
        const queryString = queryParams.toString();
        return `/nova/add-campaign${queryString ? `?${queryString}` : ''}`;
    },
    changeEmail: () => '/change-email',
    connectedChannels: () => '/connected-channels',
    battlePasses: () => '/battle-passes',
    battlePassDetails: (mnemonicId) => `/battle-passes/${mnemonicId}`,
    creatorDashboard: () => '/creator-dashboard',
    creatorsLeaderboard: () => '/creators-leaderboard',
    ambassadorProgram: () => '/ambassador-program',
    reviewClips: () => '/review-clips',
    // Redesign A/B route for Community Reviews. The legacy `reviewClips` route above is left untouched.
    reviewClipsRedesign: () => '/nova/review-clips',
    // Redesign A/B route for the admin Review Dare page. The legacy `/review-project/:recordId` route is left untouched.
    reviewProjectRedesign: (recordId) => `/nova/review-project/${recordId}`,
    // Redesign A/B route for the brand Review Dare page. The legacy `/review-drop-project/:recordId` route is left untouched.
    reviewDropProjectRedesign: (recordId) => `/nova/review-drop-project/${recordId}`,
    payoutMethod: () => '/payout-method',
    applications: () => '/applications',
    application: (applicationId) => `/application/${applicationId}`,
    // Redesign A/B routes for the applications (developer integration) portal. The legacy
    // `applications`/`application` routes above are left untouched.
    applicationsRedesign: () => '/nova/applications',
    applicationRedesign: (applicationId) => `/nova/application/${applicationId}`,
    satisfactionSurvey: () => '/satisfaction-survey',
    authPopupCallback: () => '/auth/popup-callback',
    editCreatorDare: (dareId) => `/creator-dare/${dareId}/edit`,
};
